import { arrayField } from "@common";
import * as cn from "classnames";
import * as React from "react";
import { FieldError } from "../ErrorMessage";
import { DeviceMapping } from "@store";

export interface PlacementTypeComponentProps {
    value: string[] | null;
    field: any | null;
    onChange: { events: any };
    isDisabled: boolean;
    onCheckBoxAction: (fieldName: string) => void;
    deviceMapping: DeviceMapping[];
    // Other props here
}

export const PlacementTypeComponent = (props: PlacementTypeComponentProps) => (
    <>
        <label className="common-checkbox tour-campaign-device-targeting">
            <input
                type="checkbox"
                name="Enable OS Targeting"
                value="deviceType"
                id=""
                checked={!props.isDisabled}
                onChange={e => props.onCheckBoxAction(e.target.value)}
            />
            Enable OS Targeting
            <span className="checkmark" />
        </label>
        <div className={cn("sub-check-boxes-wrapper", props.field.visualState)}>
            {props.deviceMapping &&
                props.deviceMapping.map((device, index) => (
                    <label
                        key={index}
                        className={cn("common-checkbox", props.isDisabled ? "common-checkbox__isDisabled" : "")}
                    >
                        <input
                            type="checkbox"
                            name="placement-type"
                            value={device.type}
                            id=""
                            checked={arrayField.toCheckbox.checked(props.field, device.type)}
                            {...arrayField.toCheckbox.events(props.field, props.onChange.events, device.type)}
                            disabled={props.isDisabled}
                        />
                        <div className="device-wrapper">
                            <span className="device-targeting-icon ">
                                <img className="" src={device.icon} />
                            </span>
                            {device.type}
                        </div>
                        <span className="checkmark" />
                    </label>
                ))}
        </div>
        <FieldError field={props.field} />
    </>
);
